// @flow

import { setProps, getProps } from '../props';
import { clearValuation } from '../State/valuation';
import { setFetching } from '../State/fetching';
import fetchValuation from '../Services/fetchValuation';

export default (props: any) => (dispatch: Function) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the valuation ID has changed
  const oldValuationId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newValuationId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldValuationId && newValuationId && oldValuationId !== newValuationId) {
    // Clear the old valuation data and show loading state
    dispatch(clearValuation());
    dispatch(setFetching(true));
    
    // Fetch the new valuation
    dispatch(fetchValuation());
  }
};